/**
 * Hello Ava
 *
 * Copyright © 2016-2017 Helloava, Inc. All rights reserved.
 *
 * Filename: history.js
 *
 * Created by robertcaslin.
 */

import { createBrowserHistory } from "history";
export default createBrowserHistory({
    forceRefresh: true
}); 



// WEBPACK FOOTER //
// ./src/utils/history.js